import type {
  SearchAdapterOptions,
  SearchAdapter,
} from "src/types/adapters/search.type";
import type { SearchStrategies } from "src/types/strategies/search.type";
import { SEARCH_STRATEGY_MAP } from "src/utils/search-provider/constants";

export function getSearchStrategy(
  strategy: SearchStrategies,
  options: SearchAdapterOptions
): SearchAdapter {
  return SEARCH_STRATEGY_MAP[strategy](options);
}
